package co.maytes.standupbot.dashboard.features.theme

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import co.maytes.standupbot.dashboard.components.widgets.SegmentedControl
import co.maytes.standupbot.dashboard.components.widgets.SegmentedOption
import com.varabyte.kobweb.compose.ui.Modifier

private val themeOptions = listOf(
    SegmentedOption(ThemePreference.System, "System"),
    SegmentedOption(ThemePreference.Light, "Light"),
    SegmentedOption(ThemePreference.Dark, "Dark"),
)

@Composable
fun ThemeSegmented(modifier: Modifier = Modifier) {
    val store = LocalThemeStore.current
    SystemThemeListener(store)
    val selected by store.preference

    SegmentedControl(
        options = themeOptions,
        selected = selected,
        onSelect = store::setPreference,
        ariaLabel = "Theme",
        modifier = modifier,
    )
}
